// export const base_url = "http://localhost:5600/api";
export const base_url = "https://stagedev.legacyx.uk/api";
// export const base_url = "http://localhost:4400/api";
// export const base_url = "http://localhost:5600/api";

// Admin auth routes are mounted at /api/admin/auth on the backend
export const admin_base_url = base_url + "/admin/auth";
